import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchLikes, setLike } from './community';
import { eggState, announceEgg, playPops } from './eggs';

export const celebrateLikes = (total) => {
  eggState.fireworksUntil = performance.now() + 10000;
  playPops(10, 8);
  announceEgg('fireworks', total ? `Like number ${total.toLocaleString()}! Fireworks over the mountains` : 'Fireworks over the mountains!', '🎆');
};

// Like counts for all paintings plus which ones this visitor liked. Optimistic updates.
export const useLikes = () => {
  const [likes, setLikes] = useState({ available: false, counts: {}, mine: new Set() });
  const likesRef = useRef(likes);
  likesRef.current = likes;

  useEffect(() => {
    fetchLikes()
      .then((d) => setLikes({ available: true, counts: d.counts || {}, mine: new Set(d.mine || []) }))
      .catch(() => {}); // API unavailable: like buttons stay hidden
  }, []);

  const apply = (id, liked, count) =>
    setLikes((p) => {
      const mine = new Set(p.mine);
      if (liked) mine.add(id); else mine.delete(id);
      return { ...p, mine, counts: { ...p.counts, [id]: count } };
    });

  const toggleLike = useCallback((id) => {
    const prev = likesRef.current;
    const liked = !prev.mine.has(id);
    const before = prev.counts[id] || 0;
    apply(id, liked, Math.max(0, before + (liked ? 1 : -1))); // show it immediately
    setLike(id, liked)
      .then((r) => {
        apply(id, liked, r.count);
        // Secret: the gallery's 1,000th like (and every 1,000 after) sets off fireworks.
        const total = Object.entries(likesRef.current.counts).reduce((n, [k, c]) => n + (k === id ? r.count : c), 0);
        if (liked && total > 0 && total % 1000 === 0) celebrateLikes(total);
      })
      .catch(() => apply(id, !liked, before)); // undo on failure
  }, []);

  return { likes, toggleLike };
};
